import React, { useState } from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import * as actions from '../actions'
import IconButton from '@material-ui/core/IconButton'
// import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit'
// import ClearIcon from '@material-ui/icons/Clear'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
// import PublishIcon from '@material-ui/icons/Publish'
import StorageIcon from '@material-ui/icons/Storage'
// import DehazeIcon from '@material-ui/icons/Dehaze'
import PinDropIcon from '@material-ui/icons/PinDrop'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat'
import SaveAltIcon from '@material-ui/icons/SaveAlt'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
// import PortraitIcon from '@material-ui/icons/Portrait'
import HistoryIcon from '@material-ui/icons/History'
import TodayIcon from '@material-ui/icons/Today'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import FindInPageIcon from '@material-ui/icons/FindInPage'
import { Dialog } from '@material-ui/core'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Fade from '@material-ui/core/Fade'

import DialogoComunicacionUpdate from '../components/DialogoComunicacionUpdate'
import DialogoCOEMsView from '../components/DialogoCOEMsView'
import { FORM_LISTADO_COEMS } from '../../../config/forms'
import DialogoCierreDeCarga from '../components/DialogoCierreDeCarga'
import DialogoComunicacionHistorial from '../components/DialogoComunicacionHistorial'

function EdicionCaratulaActiva (props) {
  const {
    id,
    anularCaratula,
    rectificarCaratula,
    submitActualizarCaratula,
    solicitarCambioBuque,
    solicitarCambioFechas,
    solicitarCambioLOT,
    solicitarCierreCargaGranel,
    closeModal,
    resetCaratulaExportador
  } = props

  const [open, setOpen] = useState(false)

  const [openCoems, setOpenCoems] = useState(false)

  const [openCierreDeCarga, setOpenCierreDeCarga] = useState(false)

  const [openHistory, setOpenHistory] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleOpenHistory = () => {
    handleCloseMenu()
    setOpenHistory(true)
  }

  const handleClose = () => {
    resetCaratulaExportador()
    setOpen(false)
  }

  const handleCloseHistory = () => {
    resetCaratulaExportador()
    setOpenHistory(false)
  }

  const handleOpenCierreDeCarga = () => setOpenCierreDeCarga(true)

  const handleCloseCierreDeCarga = () => {
    closeModal()
    resetCaratulaExportador()
    setOpenCierreDeCarga(false)
  }

  const handleOpenCoems = () => setOpenCoems(true)

  const handleCloseCoems = () => {
    closeModal()
    resetCaratulaExportador()
    setOpenCoems(false)
  }

  const handleSubmit = async () => {
    submitActualizarCaratula()
  }

  const onClickAnular = (id) => {
    const result = window.confirm('¿Desea ANULAR la Carátula en Aduana?')
    handleCloseMenu()
    if (result) anularCaratula(id)
  }

  const onClickRectificarCaratula = (id) => {
    const result = window.confirm('¿Desea RECTIFICAR la Carátula en Aduana?')
    handleCloseMenu()
    if (result) rectificarCaratula(id)
  }

  const onClickSolicitarCambioBuque = (id) => {
    const result = window.confirm('¿Desea SOLICITAR CAMBIO DE BUQUE en Aduana?')
    handleCloseMenu()
    if (result) solicitarCambioBuque(id)
  }

  const onClickSolicitarCambioFechas = (id) => {
    const result = window.confirm('¿Desea SOLICITAR CAMBIO DE FECHAS en Aduana?')
    handleCloseMenu()
    if (result) solicitarCambioFechas(id)
  }

  const onClickSolicitarCambioLOT = (id) => {
    const result = window.confirm('¿Desea SOLICITAR CAMBIO DE LUGAR OPERATIVO en Aduana?')
    handleCloseMenu()
    if (result) solicitarCambioLOT(id)
  }

  const regresarCaratulaEstadoInactiva = (id) => {
    const result = window.confirm('¿Desea regresar la CARATULA al estado Inactiva?')
    handleCloseMenu()
    if (result) props.regresarCaratulaEstadoInactiva(id)
  }

  const consultaEstadosCoem = (id) => {
    const result = window.confirm('¿Desea consultar estados de COEMs en Aduana?')
    handleCloseMenu()
    if (result) props.consultaEstadosCoem(id)
  }

  const consultaSolicitudes = (id) => {
    const result = window.confirm('¿Desea consultar el estado de las Solicitudes en Aduana?')
    handleCloseMenu()
    if (result) props.consultaSolicitudes(id)
  }

  const consultaNoAbordo = (id) => {
    const result = window.confirm('¿Desea consultar solicitudes de No a bordo en Aduana?')
    handleCloseMenu()
    if (result) props.consultaNoAbordo(id)
  }

  function onClickCoems () {
    handleCloseMenu()
    handleOpenCoems()
  }

  const onClickSolicitarCierreDeCarga = (id) => {
    window.alert('Por favor primero verifique que no tenga solicitudes pendientes en Aduana')
    const result = window.confirm('¿Desea SOLICITAR CIERRE DE CARGA A GRANEL en Aduana?')
    handleCloseMenu()
    if (result) solicitarCierreCargaGranel(id)
  }

  function onClickCierreDeCarga () {
    handleCloseMenu()
    handleOpenCierreDeCarga()
  }

  // const handleSubmitCierreDeCarga = async (id) => {
  //   // props.solicitarCierreCargaGranel(id)
  // }

  const handleSubmitCoems = async () => {
    props.submitUpdateCoems()
  }

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open1 = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleClickAway = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <div>
        <Dialog
          open={openHistory}
          onClose={handleCloseHistory}
          fullWidth
          maxWidth='lg'>
          <DialogoComunicacionHistorial id={id} handleClose={handleCloseHistory} />
        </Dialog>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='md'>
          <DialogoComunicacionUpdate id={id} handleClose={handleClose} handleSubmit={handleSubmit} />
        </Dialog>
        <Dialog
          open={openCoems}
          onClose={handleCloseCoems}
          fullWidth
          maxWidth='lg'>
          <DialogoCOEMsView id={id} handleClose={handleCloseCoems} handleSubmit={handleSubmitCoems} />
        </Dialog>
        <Dialog
          open={openCierreDeCarga}
          onClose={handleCloseCierreDeCarga}
          fullWidth
          maxWidth='lg'>
          <DialogoCierreDeCarga id={id} handleClose={handleCloseCierreDeCarga} handleSubmit={onClickSolicitarCierreDeCarga} />
        </Dialog>
        <ClickAwayListener onClickAway={() => handleClickAway()}>
          <div>
            <IconButton aria-controls='fade-menu' aria-haspopup='true' onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id='fade-menu'
              anchorEl={anchorEl}
              keepMounted
              open={open1}
              onClose={handleCloseMenu}
              TransitionComponent={Fade}
            >
              <MenuItem onClick={onClickCoems}><StorageIcon fontSize='small' color='action' />&nbsp;COEMs asociados...</MenuItem>
              <MenuItem onClick={() => handleOpen()}><EditIcon fontSize='small' color='action' />&nbsp;Editar Carátula</MenuItem>
              <MenuItem onClick={() => onClickRectificarCaratula(id)}><PlaylistAddCheckIcon fontSize='small' color='action' />&nbsp;Rectificar Carátula</MenuItem>
              <MenuItem onClick={() => onClickAnular(id)}><HighlightOffIcon fontSize='small' color='error' />&nbsp;Anular Carátula</MenuItem>
              <MenuItem onClick={() => onClickSolicitarCambioBuque(id)}><DirectionsBoatIcon fontSize='small' color='action' />&nbsp;Solicitar cambio de Buque</MenuItem>
              <MenuItem onClick={() => onClickSolicitarCambioFechas(id)}><TodayIcon fontSize='small' color='action' />&nbsp;Solicitar cambio de Fechas</MenuItem>
              <MenuItem onClick={() => onClickSolicitarCambioLOT(id)}><PinDropIcon fontSize='small' color='action' />&nbsp;Solicitar cambio de Lugar Op.</MenuItem>
              <MenuItem onClick={onClickCierreDeCarga}><SaveAltIcon fontSize='small' color='action' />&nbsp;Solicitar Cierre de Carga</MenuItem>
              <MenuItem onClick={() => consultaEstadosCoem(id)}><FindInPageIcon fontSize='small' color='action' />&nbsp;Consultar Estado de COEMs</MenuItem>
              <MenuItem onClick={() => consultaNoAbordo(id)}><FindInPageIcon fontSize='small' color='action' />&nbsp;Consultar No a Bordo</MenuItem>
              <MenuItem onClick={() => consultaSolicitudes(id)}><FindInPageIcon fontSize='small' color='action' />&nbsp;Consultar Solicitudes</MenuItem>
              <MenuItem onClick={() => regresarCaratulaEstadoInactiva(id)}><SettingsBackupRestoreIcon fontSize='small' color='action' />&nbsp;Regresar al estado Inactiva</MenuItem>
              <MenuItem onClick={() => handleOpenHistory()}><HistoryIcon fontSize='small' color='action' />&nbsp;Historial</MenuItem>
            </Menu>
          </div>
        </ClickAwayListener>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_LISTADO_COEMS,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EdicionCaratulaActiva))
